import React from 'react'

const Leaf = (props) => {
    if (props.text.text === '' || props.text.text === ' ') return null
    return <span {...props.attributes}>{props.children}</span>
}

export default Leaf
